import { render } from "./CompKeyboardSet.vue?vue&type=template&id=3620cc2b&scoped=true"
import script from "./CompKeyboardSet.vue?vue&type=script&lang=js"
export * from "./CompKeyboardSet.vue?vue&type=script&lang=js"

import "./CompKeyboardSet.vue?vue&type=style&index=0&id=3620cc2b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3620cc2b"]])

export default __exports__